import { useState } from "react";
import { useAuth } from "@/hooks/useAuth";
import { Navigate } from "react-router-dom";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { FlowerCollection } from "@/components/cms/FlowerCollection";
import { MediaLibrary } from "@/components/cms/MediaLibrary";
import { CSVImporter } from "@/components/cms/CSVImporter";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Database, Upload, Image } from "lucide-react";
import { SEOHead } from "@/components/SEOHead";

const CMS = () => {
  const { user, isAdmin } = useAuth();

  if (!user) {
    return <Navigate to="/auth" replace />;
  }

  if (!isAdmin) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Card>
          <CardHeader>
            <CardTitle>Access Denied</CardTitle>
          </CardHeader>
          <CardContent>
            <p>You need admin privileges to access the CMS.</p>
          </CardContent>
        </Card>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background">
      <SEOHead 
        title="Content Management System - Andean Bloom"
        description="Manage flower catalog, upload images, and import data"
      />
      
      <div className="container mx-auto py-8">
        <div className="mb-8">
          <h1 className="text-3xl font-bold mb-2">Content Management System</h1>
          <p className="text-muted-foreground">
            Manage your flower catalog, upload images, and import data
          </p>
        </div>

        <Tabs defaultValue="flowers" className="space-y-6">
          <TabsList className="grid w-full grid-cols-3">
            <TabsTrigger value="flowers" className="flex items-center gap-2">
              <Database className="h-4 w-4" />
              Flower Collection
            </TabsTrigger>
            <TabsTrigger value="import" className="flex items-center gap-2">
              <Upload className="h-4 w-4" />
              CSV Import
            </TabsTrigger>
            <TabsTrigger value="media" className="flex items-center gap-2">
              <Image className="h-4 w-4" />
              Media Library
            </TabsTrigger>
          </TabsList>

          <TabsContent value="flowers">
            <FlowerCollection />
          </TabsContent>

          <TabsContent value="import">
            <CSVImporter />
          </TabsContent>

          <TabsContent value="media">
            <MediaLibrary />
          </TabsContent>
        </Tabs>
      </div>
    </div>
  );
};

export default CMS;